import * as React from "react"

function SvgComponent(props) {
  return (
    <svg
      data-name="Group 672"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width={248.718}
      height={220}
      viewBox="0 0 248.718 247.326"
      {...props}
    >
      <defs>
        <linearGradient
          id="prefix__a"
          x1={0.453}
          y1={1.21}
          x2={0.493}
          y2={0.605}
          gradientUnits="objectBoundingBox"
        >
          <stop offset={0} stopColor="#26264f" />
          <stop offset={1} stopColor="#444b8c" />
        </linearGradient>
        <linearGradient
          id="prefix__f"
          x1={0.341}
          y1={0.939}
          x2={0.642}
          y2={-0.277}
          xlinkHref="#prefix__a"
        />
        <linearGradient
          id="prefix__g"
          x1={0}
          y1={0.5}
          x2={1}
          y2={0.5}
          xlinkHref="#prefix__a"
        />
        <linearGradient
          id="prefix__h"
          x1={0.384}
          y1={1.047}
          x2={0.649}
          y2={-0.417}
          xlinkHref="#prefix__a"
        />
        <linearGradient
          id="prefix__i"
          x1={0}
          y1={0.499}
          x2={1}
          y2={0.499}
          xlinkHref="#prefix__a"
        />
        <linearGradient
          id="prefix__j"
          x1={0.475}
          y1={1.004}
          x2={0.576}
          y2={-0.995}
          xlinkHref="#prefix__a"
        />
        <linearGradient
          id="prefix__b"
          x1={0.429}
          y1={0.313}
          x2={1.075}
          y2={1.164}
          gradientUnits="objectBoundingBox"
        >
          <stop offset={0} stopColor="#fcb148" />
          <stop offset={0.05} stopColor="#fdba46" />
          <stop offset={0.14} stopColor="#ffc244" />
          <stop offset={0.32} stopColor="#ffc444" />
          <stop offset={0.48} stopColor="#fdb946" />
          <stop offset={0.78} stopColor="#f99c4d" />
          <stop offset={0.87} stopColor="#f8924f" />
          <stop offset={1} stopColor="#f8924f" />
        </linearGradient>
        <linearGradient
          id="prefix__k"
          x1={0.546}
          y1={0.061}
          x2={0.39}
          y2={1.002}
          xlinkHref="#prefix__b"
        />
        <linearGradient
          id="prefix__l"
          x1={0}
          y1={0.5}
          x2={1}
          y2={0.5}
          xlinkHref="#prefix__b"
        />
        <linearGradient
          id="prefix__m"
          x1={-0.087}
          y1={0.46}
          x2={-0.449}
          y2={0.842}
          xlinkHref="#prefix__b"
        />
        <linearGradient
          id="prefix__n"
          x1={-3.514}
          y1={0.938}
          x2={-2.815}
          y2={0.938}
          xlinkHref="#prefix__b"
        />
        <linearGradient
          id="prefix__o"
          x1={-3.546}
          y1={1.324}
          x2={-3.272}
          y2={0.825}
          xlinkHref="#prefix__b"
        />
        <linearGradient
          id="prefix__c"
          x1={-5.604}
          y1={4.271}
          x2={-5.166}
          y2={6.202}
          gradientUnits="objectBoundingBox"
        >
          <stop offset={0} stopColor="#444b8c" />
          <stop offset={1} stopColor="#26264f" />
        </linearGradient>
        <linearGradient
          id="prefix__p"
          x1={-5.849}
          y1={5.677}
          x2={-5.642}
          y2={5.051}
          xlinkHref="#prefix__c"
        />
        <linearGradient
          id="prefix__q"
          x1={-7.529}
          y1={0.294}
          x2={-6.545}
          y2={0.294}
          xlinkHref="#prefix__b"
        />
        <linearGradient
          id="prefix__r"
          x1={-8.025}
          y1={-0.262}
          x2={-7.565}
          y2={1.748}
          gradientUnits="objectBoundingBox"
        >
          <stop offset={0} stopColor="#ff9085" />
          <stop offset={1} stopColor="#fb6fbb" />
        </linearGradient>
        <linearGradient
          id="prefix__s"
          x1={-11.773}
          y1={-0.022}
          x2={-10.374}
          y2={1.946}
          xlinkHref="#prefix__b"
        />
        <linearGradient
          id="prefix__t"
          y1={0.5}
          x2={1}
          y2={0.5}
          gradientUnits="objectBoundingBox"
        >
          <stop offset={0} stopColor="#165a9f" />
          <stop offset={1} stopColor="#003586" />
        </linearGradient>
        <linearGradient
          id="prefix__d"
          x1={0.425}
          y1={0.687}
          x2={0.693}
          y2={-0.203}
          gradientUnits="objectBoundingBox"
        >
          <stop offset={0} stopColor="#311944" />
          <stop offset={1} stopColor="#6b3976" />
        </linearGradient>
        <linearGradient
          id="prefix__u"
          x1={0.464}
          y1={0.589}
          x2={0.756}
          y2={-0.579}
          xlinkHref="#prefix__d"
        />
        <linearGradient
          id="prefix__e"
          x1={0.16}
          y1={-0.868}
          x2={0.81}
          y2={1.927}
          gradientUnits="objectBoundingBox"
        >
          <stop offset={0} stopColor="#ffc444" />
          <stop offset={1} stopColor="#f36f56" />
        </linearGradient>
        <linearGradient
          id="prefix__v"
          x1={0.153}
          y1={0.104}
          x2={1.943}
          y2={2.224}
          xlinkHref="#prefix__e"
        />
        <linearGradient
          id="prefix__w"
          x1={0}
          y1={0.5}
          x2={1}
          y2={0.5}
          xlinkHref="#prefix__e"
        />
        <linearGradient
          id="prefix__x"
          x1={0.36}
          y1={-2.136}
          x2={0.658}
          y2={2.425}
          xlinkHref="#prefix__e"
        />
        <linearGradient
          id="prefix__y"
          x1={0}
          y1={0.5}
          x2={1}
          y2={0.5}
          xlinkHref="#prefix__a"
        />
        <linearGradient
          id="prefix__z"
          y1={0.5}
          x2={1}
          y2={0.5}
          gradientUnits="objectBoundingBox"
        >
          <stop offset={0} stopColor="#003586" />
          <stop offset={1} stopColor="#444b8c" />
        </linearGradient>
        <linearGradient
          id="prefix__A"
          x1={0.253}
          y1={0.815}
          x2={-0.594}
          y2={3.05}
          gradientUnits="objectBoundingBox"
        >
          <stop offset={0} stopColor="#FCB148" />
          <stop offset={0.83} stopColor="#FCB148" />
          <stop offset={1} stopColor="#FCB148" />
        </linearGradient>
      </defs>
      <path
        data-name="Path 3652"
        d="M245.06 105.646c-6.738-44.129-34.38-98.341-88.986-104.013 0 0-41.459-5.043-82.326 2.6-24.259 4.535-45.527 18.039-58.986 37.445a81.209 81.209 0 00-12.5 65.631c3.544 14.654 5.939 29.819 5.281 44.873-1.148 26.207-.486 50.668 24.946 66.3 22.711 13.953 51.289 26.259 78.554 28.416 18.529 1.465 39.308-.905 57.165-5.729 91.01-24.577 83.592-91.4 76.852-135.523z"
        fill="none"
      />
      <path
        data-name="Rectangle 425"
        fill="#fff"
        d="M171.316 78.491h68.3v5.794h-68.3z"
      />
      <path
        data-name="Rectangle 426"
        fill="#fff"
        d="M202.416 78.491h5.488v125.623h-5.488z"
      />
      <rect
        data-name="Rectangle 427"
        width={5.794}
        height={2.439}
        rx={1.219}
        transform="translate(171.925 77.271)"
        fill="#bfc8d6"
      />
      <rect
        data-name="Rectangle 428"
        width={5.794}
        height={2.439}
        rx={1.219}
        transform="translate(171.925 75.137)"
        fill="#bfc8d6"
      />
      <rect
        data-name="Rectangle 429"
        width={5.794}
        height={2.439}
        rx={1.219}
        transform="translate(232.298 77.271)"
        fill="#bfc8d6"
      />
      <rect
        data-name="Rectangle 430"
        width={5.794}
        height={2.439}
        rx={1.219}
        transform="translate(232.298 75.137)"
        fill="#bfc8d6"
      />
      <path
        data-name="Rectangle 431"
        fill="#fff"
        d="M171.316 98.615h68.3v4.879h-68.3z"
      />
      <rect
        data-name="Rectangle 432"
        width={5.794}
        height={2.439}
        rx={1.219}
        transform="translate(171.925 96.786)"
        fill="#bfc8d6"
      />
      <rect
        data-name="Rectangle 433"
        width={5.794}
        height={2.439}
        rx={1.219}
        transform="translate(171.925 94.346)"
        fill="#bfc8d6"
      />
      <rect
        data-name="Rectangle 434"
        width={5.794}
        height={2.439}
        rx={1.219}
        transform="translate(232.298 96.786)"
        fill="#bfc8d6"
      />
      <rect
        data-name="Rectangle 435"
        width={5.794}
        height={2.439}
        rx={1.219}
        transform="translate(232.298 94.346)"
        fill="#bfc8d6"
      />
      <path
        data-name="Rectangle 436"
        fill="#fff"
        d="M86.245 40.682h68.605v5.488H86.245z"
      />
      <path
        data-name="Rectangle 437"
        fill="#fff"
        d="M117.651 40.682h5.488v125.623h-5.488z"
      />
      <rect
        data-name="Rectangle 438"
        width={5.794}
        height={2.439}
        rx={1.219}
        transform="translate(86.855 39.462)"
        fill="#bfc8d6"
      />
      <rect
        data-name="Rectangle 439"
        width={5.794}
        height={2.439}
        rx={1.219}
        transform="translate(86.855 37.328)"
        fill="#bfc8d6"
      />
      <rect
        data-name="Rectangle 440"
        width={5.794}
        height={2.439}
        rx={1.219}
        transform="translate(147.532 39.462)"
        fill="#bfc8d6"
      />
      <rect
        data-name="Rectangle 441"
        width={5.794}
        height={2.439}
        rx={1.219}
        transform="translate(147.532 37.328)"
        fill="#bfc8d6"
      />
      <path
        data-name="Rectangle 442"
        fill="#fff"
        d="M86.245 60.197h68.605v5.488H86.245z"
      />
      <rect
        data-name="Rectangle 443"
        width={5.794}
        height={2.439}
        rx={1.219}
        transform="translate(86.855 58.672)"
        fill="#bfc8d6"
      />
      <rect
        data-name="Rectangle 444"
        width={5.794}
        height={2.439}
        rx={1.219}
        transform="translate(86.855 56.537)"
        fill="#bfc8d6"
      />
      <rect
        data-name="Rectangle 445"
        width={5.794}
        height={2.439}
        rx={1.219}
        transform="translate(147.532 58.672)"
        fill="#bfc8d6"
      />
      <rect
        data-name="Rectangle 446"
        width={5.794}
        height={2.439}
        rx={1.219}
        transform="translate(147.532 56.537)"
        fill="#bfc8d6"
      />
      <path
        data-name="Path 3653"
        d="M159.737 101.251a72.324 72.324 0 01-20.386-2.935 85.864 85.864 0 01-26.87-13.633 105.078 105.078 0 01-22.872-23.169l.789-.525A104.089 104.089 0 00113.07 83.94c13.292 9.829 34.786 20.376 61.7 14.8l.192.929a75.049 75.049 0 01-15.225 1.582z"
        fill="#bfc8d6"
      />
      <path
        data-name="Path 3654"
        d="M222.76 100.138c-14.082 0-26.291-1.413-36.426-4.223-10.789-2.989-19.268-7.566-25.2-13.589-9.961-10.124-9.275-20.664-9.238-21.111l.944.072c-.008.1-.676 10.587 8.993 20.394 5.819 5.9 14.157 10.386 24.783 13.329 13.363 3.7 30.382 4.953 50.585 3.722l.057.946q-7.543.461-14.498.46z"
        fill="#bfc8d6"
      />
      <path
        data-name="Path 3655"
        d="M174.078 80.372a113.1 113.1 0 01-35.805-5.653 106.61 106.61 0 01-27.179-13.597c-14.252-9.893-21.409-20.093-21.48-20.195l.779-.54c.07.1 7.15 10.182 21.275 19.979 13.026 9.035 34.891 19.67 65.041 19.026l.02.947q-1.328.034-2.651.033z"
        fill="#bfc8d6"
      />
      <path
        data-name="Path 3656"
        d="M237.21 80.344c-15.75-.737-30.033-3.2-42.439-7.314A96.341 96.341 0 01168.7 60.069c-12.564-9.055-16.59-17.6-16.76-17.955l.86-.4c.04.088 4.124 8.718 16.518 17.628 11.447 8.23 32.522 18.4 67.937 20.052z"
        fill="#bfc8d6"
      />
      <path
        data-name="Path 3657"
        d="M76.927 51.969c0-15.723-13.387-28.471-29.9-28.471s-29.9 12.747-29.9 28.471a28.053 28.053 0 0012.5 23.156 11.748 11.748 0 015.158 9.691v2.178a8.568 8.568 0 008.568 8.573h7.354a8.568 8.568 0 008.568-8.573v-2.178a11.748 11.748 0 015.158-9.691 28.048 28.048 0 0012.494-23.156z"
        fill="#f4f7fa"
        opacity={0.75}
      />
      <path
        data-name="Path 3658"
        d="M470.546 1189.362c0 1.944-2.97 3.511-6.633 3.511s-6.633-1.572-6.633-3.511 2.97-3.512 6.633-3.512 6.633 1.572 6.633 3.512z"
        transform="translate(-416.887 -1081.1)"
        fill="url(#prefix__a)"
      />
      <path
        data-name="Path 3659"
        d="M432.6 1154.59v3.587a3.151 3.151 0 001.786 2.847 16.8 16.8 0 007.721 1.426 17.335 17.335 0 006.16-1.074 3.2 3.2 0 001.958-2.967v-1.984z"
        transform="translate(-394.387 -1052.602)"
        fill="#26264F"
      />
      <path
        data-name="Path 3660"
        d="M432.6 1157.731a3.46 3.46 0 00.929.649c1.706.814 12.878 2.631 15.573 1.619a3.645 3.645 0 00.941-.52 3.243 3.243 0 00.183-1.07v-1.984l-17.626-1.835z"
        transform="translate(-394.387 -1052.602)"
        opacity={0.3}
        fill="#26264F"
      />
      <path
        data-name="Path 3661"
        d="M422.315 1126.9a1.678 1.678 0 00-1.855 1.673v.1a3.533 3.533 0 002 3.194c1.706.814 12.878 2.631 15.573 1.618a3.259 3.259 0 002.2-3.124v-.082a1.678 1.678 0 00-1.508-1.673z"
        transform="translate(-383.32 -1027.353)"
        fill="#26264F"
      />
      <path
        data-name="Path 3662"
        d="M441.642 1128.611l-16.409-1.705a1.677 1.677 0 00-1.572.74 3.512 3.512 0 001.719 1.8c1.706.813 13.354 2.868 15.573 1.823a3.851 3.851 0 001.906-1.933 1.678 1.678 0 00-1.217-.725z"
        transform="translate(-386.237 -1027.355)"
        opacity={0.3}
        fill="url(#prefix__i)"
      />
      <path
        data-name="Path 3663"
        d="M421.654 1061.19a1.215 1.215 0 00-1.215 1.214v2.809a3.533 3.533 0 002 3.194c1.706.814 13.354 2.868 15.573 1.823a3.708 3.708 0 002.2-3.328v-4.5a1.216 1.216 0 00-1.212-1.212z"
        transform="translate(-383.301 -967.453)"
        fill="url(#prefix__g)"
      />
      <path
        data-name="Path 3664"
        d="M442.495 1047.56c0 1.258-4.317 2.28-9.642 2.28s-9.642-1.022-9.642-2.28 4.317-2.28 9.642-2.28 9.642 1.02 9.642 2.28z"
        transform="translate(-385.827 -952.948)"
        fill="url(#prefix__j)"
      />
      <path
        data-name="Path 3665"
        d="M253.663 294.491c0-15.723-13.387-28.471-29.9-28.471s-29.9 12.747-29.9 28.471a28.053 28.053 0 0012.5 23.156 11.748 11.748 0 015.158 9.691v2.178a8.568 8.568 0 008.568 8.573h7.354a8.568 8.568 0 008.568-8.573v-2.178a11.748 11.748 0 015.158-9.691 28.048 28.048 0 0012.494-23.156z"
        transform="translate(-176.736 -242.522)"
        fill="#FCB148"
      />
      <ellipse
        data-name="Ellipse 140"
        cx={7.055}
        cy={1.668}
        rx={7.055}
        ry={1.668}
        transform="translate(39.971 91.147)"
        fill="#f4f7fa"
        opacity={0.5}
      />
      <path
        data-name="Path 3666"
        d="M224.3 364.739c.641-10.974 19.141-13.542 19.062-23.342-.049-6.037-7.4-10.52-8.97-11.417-11.572-6.616-25.8 1.024-28.745-4.383a5.051 5.051 0 01-.194-3.646 7.815 7.815 0 011.957-3.51 27.722 27.722 0 00-1.055 47 11.748 11.748 0 015.158 9.691v2.178a8.568 8.568 0 008.568 8.573h7.354a8.568 8.568 0 008.568-8.573v-1.742a5.622 5.622 0 01-3.445 1.306c-4.413-.042-8.572-6.674-8.258-12.135z"
        transform="translate(-176.736 -290.312)"
        opacity={0.3}
        fill="#FCB148"
      />
      <ellipse
        data-name="Ellipse 141"
        cx={25.731}
        cy={24.814}
        rx={25.731}
        ry={24.814}
        transform="translate(21.773 28.265)"
        fill="#f4f7fa"
        opacity={0.44}
      />
      <path
        data-name="Path 3667"
        d="M56.773 33.837L36.746 55.885l8.232-.051-6.674 16.585 19.988-22.166-7.429.02z"
        fill="#fff"
      />
      <path
        data-name="Path 3668"
        d="M87.617 1442.778a7.873 7.873 0 01-6.916-11.842l53.718-93.025a7.989 7.989 0 0113.833.018l53.721 93.052a7.84 7.84 0 010 7.9 7.926 7.926 0 01-6.916 3.9z"
        transform="translate(-72.6 -1216.1)"
        fill="#FCB148"
      />
      <path
        data-name="Path 3669"
        d="M234.637 1473.026a4.491 4.491 0 01-3.917 2.223H123.281a4.476 4.476 0 01-3.918-6.729l53.72-93.034a4.519 4.519 0 013.051-2.174 4.338 4.338 0 01.866-.082 4.52 4.52 0 013.916 2.263l53.723 93.027a4.5 4.5 0 01-.002 4.506z"
        transform="translate(-108.264 -1251.929)"
        fill="url(#prefix__l)"
      />
      <path
        data-name="Path 3670"
        d="M589.171 1668.7h-13l-16.616 36.782 19.868-5.089-7.947 18.948-4.877-3.981.723 19.21 16.255-13.12h-7.946l17.519-30.683-16.8 4.138z"
        transform="translate(-510.123 -1521.299)"
        fill="url(#prefix__g)"
      />
      <path
        data-name="Path 3671"
        d="M174.466 1465.368c-11.5 4.77-19.237 7.685-24.07 10.732h-27.137a4.476 4.476 0 01-3.918-6.731l53.72-93.035a4.521 4.521 0 013.051-2.174c-4.712 9.293-11.2 28.484 4.888 43.931 22.083 21.209 19.408 36.509-6.534 47.277z"
        transform="translate(-108.243 -1252.777)"
        opacity={0.3}
        fill="#FCB148"
      />
      <path
        data-name="Path 3672"
        d="M1819.332 1475.159l38.267 3.587c3.394.691 9.041 8.386 8.12 11.088l-16.021 46.986-20.162 40.418c-1.26 2.527-4.547 3.64-7.618 2.593l-31.012-10.574c-2.8-.956-9.917-6.567-9.33-9.156l14.729-37.923 15.917-43.588c.915-2.508 4.089-4.046 7.11-3.431z"
        transform="translate(-1624.173 -1344.731)"
        fill="url(#prefix__m)"
      />
      <path
        data-name="Path 3673"
        d="M1812.94 1417.728l41.888 8.531c3.392.691 5.42 3.445 4.5 6.143l-16.023 46.986-20.16 40.419c-1.26 2.525-4.548 3.639-7.617 2.592l-31.012-10.575a5.48 5.48 0 01-3.871-6.222l9.27-40.856 15.918-43.585c.913-2.514 4.086-4.049 7.107-3.433z"
        transform="translate(-1623.247 -1292.373)"
        fill="#F8924F"
      />
      <path
        data-name="Path 3674"
        d="M1830.858 1533.259a4.617 4.617 0 005.691-1.943l20.1-40.261 16-46.816c.688-2.016-.825-4.078-3.357-4.6l-41.886-8.6a4.691 4.691 0 00-5.331 2.567l-15.9 43.608-9.238 40.867a4.1 4.1 0 002.905 4.657z"
        transform="translate(-1638.126 -1304.539)"
        fill="#F8924F"
      />
      <path
        data-name="Path 3675"
        d="M2011.5 1527.552l38.738 10.983 10.909-31.578-38.654-9.257z"
        transform="translate(-1833.819 -1365.404)"
        fill="url(#prefix__c)"
      />
      <path
        data-name="Path 3676"
        d="M2020.98 1534.087l37.384 10.569 10.531-30.446-37.306-8.961z"
        transform="translate(-1842.461 -1372.287)"
        fill="url(#prefix__p)"
      />
      <g data-name="Group 275">
        <path
          data-name="Path 3677"
          d="M216.421 173.132l-27.272-7.731c8.937-2.2 13.287-5.394 14.625-9.03 2.008-5.463-3.553-9.764-.884-14.39 1.16-2.009 3.541-3.522 6.863-4.636l17.577 4.209z"
          fill="#fff"
          opacity={0.3}
        />
      </g>
      <path
        data-name="Path 3678"
        d="M1917.829 1960.582a17.07 17.07 0 0011.085 22.247 19.35 19.35 0 0023.859-11.989 17.059 17.059 0 00-11.8-22.269 19.413 19.413 0 00-23.144 12.011z"
        transform="translate(-1747.473 -1775.846)"
        fill="url(#prefix__q)"
      />
      <path
        data-name="Path 3679"
        d="M1938.712 1979.835a15.3 15.3 0 009.971 19.945 17.349 17.349 0 0021.356-10.749 15.292 15.292 0 00-10.548-19.963 17.4 17.4 0 00-20.779 10.767z"
        transform="translate(-1766.611 -1794.588)"
        fill="url(#prefix__r)"
      />
      <rect
        data-name="Rectangle 447"
        width={7.013}
        height={21.039}
        rx={3.506}
        transform="translate(183.207 178.197)"
        fill="url(#prefix__s)"
      />
      <circle
        data-name="Ellipse 142"
        cx={2.285}
        cy={2.285}
        r={2.285}
        transform="translate(173.111 212.349)"
        fill="#fff"
      />
      <circle
        data-name="Ellipse 143"
        cx={2.285}
        cy={2.285}
        r={2.285}
        transform="translate(165.988 210.34)"
        fill="#fff"
      />
      <path
        data-name="Path 3680"
        d="M754.088 1892.115c-4.7-12.23 1.932-32.273 6.107-41.357 12.171-26.478 34.532-27.373 52.864-28.107 18.008-.72 35.392-1.413 48.115 18.893 8.311 13.268 15.954 37.607 10.857 50.571-5.361 13.635-20.246 3.069-55.645 2.882-38.935-.205-56.433 12.39-62.298-2.882z"
        transform="translate(-686.005 -1661.411)"
        fill="url(#prefix__t)"
      />
      <path
        data-name="Path 3681"
        d="M144.053 164.027c0 3.334-8.139 7.331-18.18 7.331s-18.181-4-18.181-7.331 8.14-1.843 18.181-1.843 18.18-1.491 18.18 1.843z"
      />
      <path
        data-name="Path 3682"
        d="M119.188 140.771c-2.764 0 3.622 19.423-6.432 22.09a1.106 1.106 0 00-.247 2.044c2.7 1.461 7.75 3.313 16.037 3.313a20.452 20.452 0 0011.367-3.405 1.105 1.105 0 00-.119-1.9c-3.1-1.6-7.4-6.675-6.115-21.641z"
        fill="#f7b686"
      />
      <path
        data-name="Path 3683"
        d="M110.79 117.483c.042.243.878 17.973 4.93 26.826 1.162 2.542 6.932 2.237 10.666 1.931 3.243-.265 8.327.917 9.759-1.321 5.756-9 4.781-31.3 4.781-31.3s-2.949-7.42-15.043-7.215-15.093 11.079-15.093 11.079z"
        fill="#f7b686"
      />
      <path
        data-name="Path 3684"
        d="M113.619 127.005s-2.53-2.939-4.914-3.332-3.937 5.782-.685 9.8 7.011.685 7.011.685z"
        fill="#f7b686"
      />
      <path
        data-name="Path 3685"
        d="M138.272 127.005s2.53-2.939 4.914-3.332 3.937 5.782.685 9.8-7.011.685-7.011.685z"
        fill="#f7b686"
      />
      <path
        data-name="Path 3686"
        d="M1208.261 1073.041c.317.585.683 1.128.929 1.06 1.023-.265-2.92-10.23.712-13.719 1.877-1.8 3.993-.16 11.686-.508 7.748-.354 9.729-2.208 12.071-.784 2.133 1.293 4.043 4.987 2.461 15.926l1.325-.3a11.245 11.245 0 01.8-7.268 8.045 8.045 0 001.442-4.317c-.048-1.2-.442-1.254-.511-2.237-.191-2.88 3.092-3.656 3.254-6.5.122-2.192-1.767-2.689-1.423-4.979.294-1.943 1.766-2.312 1.536-3.719-.252-1.518-2.229-2.65-3.617-3.043-1.413-.4-1.926.044-2.757-.53-1.341-.925-.7-2.567-1.665-3.18-1.726-1.086-5.158 3.25-7.376 2.171-1.343-.654-.825-2.6-2.014-3.077-2.3-.914-6.355 5.52-7.987 4.666-.782-.409-.029-1.976-1.125-3.13a4.524 4.524 0 00-5.786.082c-1.313 1.336-.2 2.933-1.59 4.627-1.248 1.521-2.691.9-4.1 2.115-2.393 2.071-1.56 6.756-1.264 8.428 1.024 5.756 4.211 6.92 3.5 10.845a8.829 8.829 0 00-.3 3.76 7.679 7.679 0 001.799 3.611z"
        transform="translate(-1096.622 -946.256)"
        fill="url(#prefix__d)"
      />
      <g data-name="Group 276">
        <path
          data-name="Path 3687"
          d="M1237.676 1151.748c-.283-2.827 1.91-4.152 1.541-6.166a4.916 4.916 0 00-3.854-3.391c-3.675-.664-6.055 4.748-9.71 4.161-2.827-.453-2.513-3.867-5.7-5.241-5.056-2.176-10.356 4.458-13.719 2.621-1.011-.553-2.031-1.972-2.1-5.823-1.928 2.215-1.171 6.477-.891 8.055 1.024 5.756 4.211 6.92 3.5 10.845a8.82 8.82 0 00-.3 3.76 7.713 7.713 0 001.815 3.61c.317.585.682 1.128.929 1.06 1.023-.265-2.92-10.229.712-13.719 1.878-1.8 3.993-.16 11.686-.508 7.748-.353 9.729-2.208 12.071-.784 2.133 1.293 4.043 4.987 2.461 15.926l1.325-.3a11.249 11.249 0 01.795-7.268c.223-.429.519-.909.785-1.46a13.011 13.011 0 00-.552-3.066 11.051 11.051 0 01-.794-2.312z"
          transform="translate(-1096.6 -1037.396)"
          fill="url(#prefix__u)"
          opacity={0.3}
        />
      </g>
      <path
        data-name="Path 3688"
        d="M1198.182 970.35h29.632a6.043 6.043 0 016.043 6.043v20.1h-41.717v-20.1a6.043 6.043 0 016.042-6.043z"
        transform="translate(-1086.835 -884.636)"
        fill="#FFC444"
      />
      <path
        data-name="Path 3689"
        d="M1363.666 940.5h9.433a1.085 1.085 0 011.085 1.085v27.694h-11.6v-27.694a1.085 1.085 0 011.082-1.085z"
        transform="translate(-1242.22 -857.423)"
        fill="url(#prefix__v)"
      />
      <rect
        data-name="Rectangle 448"
        width={46.453}
        height={5.05}
        rx={2.525}
        transform="translate(102.936 111.553)"
        fill="url(#prefix__w)"
      />
      <path
        data-name="Path 3690"
        d="M1199.28 1316.68c.875 3.986 9.6 7.116 20.228 7.116s19.353-3.13 20.229-7.116z"
        transform="translate(-1093.344 -1200.374)"
        fill="url(#prefix__x)"
      />
      <rect
        data-name="Rectangle 449"
        width={10.671}
        height={35.675}
        rx={5.336}
        transform="translate(96.918 159.902)"
        fill="url(#prefix__g)"
      />
      <rect
        data-name="Rectangle 450"
        width={10.671}
        height={35.675}
        rx={5.336}
        transform="translate(146.008 159.902)"
        fill="#26264F"
      />
      <rect
        data-name="Rectangle 451"
        width={75.618}
        height={49.091}
        rx={24.545}
        transform="translate(88.685 189.174)"
        fill="#003586"
      />
      <path
        data-name="Path 3691"
        d="M1281.094 2267.133c15.43 1.118 16.606-15.063 16.606-15.063h-30.74s-.623 13.994 14.134 15.063z"
        transform="translate(-1155.043 -2053.138)"
        fill="url(#prefix__A)"
      />
    </svg>
  )
}

const MemoSvgComponent = React.memo(SvgComponent)
export default MemoSvgComponent
